import Backdrop from '@mui/material/Backdrop';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import React, { useEffect, useState, useContext } from 'react'
import Header from "../../components/headerAdmin/Header.js";
import "./myTalentReferral.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import SearchReferralByRecruitmentPartnerId from '../../apis/myTallentCommunityByOrgId/searchReferralByRecruitmentPartnerId.js';
import { DateTime } from "luxon";
import Autocomplete from '@mui/material/Autocomplete';
import getUsersById from '../../apis/users/getUserById.js';
import pdfIcon from "../myTalentCommunity/icons/pdf.svg"
import docIcon from "../myTalentCommunity/icons/doc.png";
import getallreferralskillResponse from '../../apis/referral/getallreferralskill.js';
import getAllPendingCandidateByInvitedIdResponse from "../../apis/pendingInvites/pendingInvites";
import revokeInviteCandidateResponse from '../../apis/inviteCandidate/revokeInviteCandidate.js';
import UpdateStatusReferralById from '../../apis/myTallentCommunityByOrgId/updateStatusReferralById.js';
import { UserTypeContext } from "../../AppRoute";
import { BlobServiceClient } from '@azure/storage-blob';
import { NotificationManager } from "react-notifications";
import SHA256 from 'crypto-js/sha256';
import DataTable from '../../components/DataTable/DataTable.js';
import Tooltip from "@mui/material/Tooltip";
import DatePicker from 'react-datepicker';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import UnauthorizedAccess from '../../components/UnauthorizedAccess/UnauthorizedAccess.js';

const styleSx = {
    backdrop: {
        zIndex: 1202,
        color: '#fff',
    },
    text: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        fontFamily: '"Segoe UI Semibold", sans-serif !important',
        fontWeight: 'bold',
        fontSize: "10px",
        color: "#ffffff !important",
        textShadow: "0px 1px 2px black !important"
    },
    sidebar_top_check_section: {},
    sidebar_top_check_section1: {},
    buttonContainer: {
        justifyContent: "flex-end !important",
        paddingRight: "40px",
        paddingBottom: "20px",
        paddingTop: "14px",
    },
    btnNO: {
        width: "25px",
        height: "37px",
        backgroundColor: "#FFFFFF",
        color: "#1885E6",
        border: "1px solid #1885E6",
        borderRadius: "5px",
        "&:hover": {
            opacity: "0.8",
            backgroundColor: "#D1E8FF"
        }
    },

    btnYES: {
        width: "25px",
        height: "37px",
        backgroundColor: "#1885E6",
        color: "#FFFFFF",
        border: "none",
        borderRadius: "5px",
        "&:hover": {
            opacity: "0.8",
            backgroundColor: "#1885E6",
        }
    },
    inviteActionBtn: {
        color: "#fff",
        backgroundColor: "#1885e6",
    },
    // backdrop: {
    //     position: 'fixed',
    //     top: 0,
    //     left: 0,
    //     right: 0,
    //     bottom: 0,
    //     backgroundColor: 'rgba(0, 0, 0, 0.7)',
    //     zIndex: 9999,
    //     display: 'flex',
    //     alignItems: 'center',
    //     justifyContent: 'center',
    // },
    tyreWrapper: {
        position: 'relative',
        width: '80vw',
        height: '80vw',
        maxWidth: '80vh',
        maxHeight: '80vh',
        // backgroundColor: 'black',
        borderRadius: '50%',
        padding: '20px',
        boxSizing: 'border-box',
    },
}

const MyTalentReferral = (props) => {
    const location = useLocation();
    const { userType, userRecords } = useContext(UserTypeContext);
    const userRecruitmentpartnerId = userType === "Admin" ? location?.state?.userRecruitmentpartnerId : userRecords?.recruitmentpartnerId
    const idContextTest = userType === "Admin" ? location?.state?.id : userRecords?.id
    const userRole = userType === "Admin" ? location?.state?.userRole : userRecords?.role?.roleName
    const history = useNavigate();
    const [filterSkill, setFilterSkill] = useState([]);
    const [filterCountry, setFilterCountry] = useState(null);
    const [filterStatus, setFilterStatus] = useState([{ name: "Pending Action" }]);
    const [company, setCompany] = useState("");
    const [referralJson, setReferralJson] = useState([]);
    const [referralSkills, setReferralSkills] = useState([]);
    const [isloading, setIsloading] = useState(false);
    const [cancelCandidateDetails, setCancelCandidateDetails] = useState({});
    const [pendingData, setPendingData] = useState([]);
    const [revokeCandidateDetails, setRevokeCandidateDetails] = useState({});
    const [openCancelModal, setOpenCancelModal] = useState(false);
    const [recruiterData, setRecruiterData] = useState([]);
    const jsonConfig = require("../../Config.json");
    const [openCandidateProfileModel, setOpenCandidateProfileModel] = useState(false);
    const [resumeDetail, setResumeDetail] = useState({ "referralId": "", "resumeUrl": "", organizationId: "" });
    const [progressLoader, setProgressLoader] = useState(false);
    const [open, setOpen] = useState(false);
    const [indexrow, setIndexRow] = useState(0);
    const [dropdownOpen, setDropdownOpen] = useState(null);
    const [selectedRowData, setSelectedRowData] = useState(null);

    const searchFunc = () => {
        search(recruiterData[0].recruitmentpartnerId, company);
    };

    const referralMenuList = [
        { name: "Skill", checked: true },
        { name: "Country", checked: true },
        { name: "Status", checked: true },
    ];
    const countryList = [
        {
            currency: "USD",
            flag: "",
            isoCode: "US",
            latitude: "38.00000000",
            longitude: "-97.00000000",
            name: "United States",
            phonecode: "+1",
        },
        {
            currency: "CAD",
            flag: "",
            isoCode: "CA",
            latitude: "60.00000000",
            longitude: "-95.00000000",
            name: "Canada",
            phonecode: "+1",
        },
        {
            currency: "INR",
            flag: "",
            isoCode: "IN",
            latitude: "20.00000000",
            longitude: "77.00000000",
            name: "India",
            phonecode: "+91",
        },
        {
            currency: "MXN",
            flag: "",
            isoCode: "MX",
            latitude: "23.00000000",
            longitude: "-102.00000000",
            name: "Mexico",
            phonecode: "+52",
        }
    ];
    const referralStatus = [
        { name: "Pending Action" },
        { name: "Invited to Test" },
        { name: "Added to Community" },
        { name: "Referral Cancelled" },
    ];

    const search = async (recruitmentPartnerId_Search, companyName) => {
        setIsloading(true)
        let skillArr = [];
        let countryJson = null;
        let statusArr = [];

        if (filterSkill.length !== 0) {
            for (let i = 0; i < filterSkill.length; i++) {
                skillArr.push(filterSkill[i]?.id);
            }
        }
        if (filterCountry !== null) {
            countryJson = JSON.stringify(filterCountry);
        }
        if (filterStatus.length !== 0) {
            for (let i = 0; i < filterStatus.length; i++) {
                statusArr.push(filterStatus[i]?.name);
            }
        }
        const referralPayload = {
            recruitmentPartnerId: recruitmentPartnerId_Search,
            data: {
                skillId: skillArr.length !== 0 ? skillArr : [],
                country: countryJson !== null ? countryJson : "",
                status: statusArr.length !== 0 ? statusArr : [],
            },
        };

        try {
            const res = await SearchReferralByRecruitmentPartnerId(referralPayload);
            const allData = res?.data?.data;

            for (let i = 0; i < allData.length; i++) {
                const change = allData[i];
                // country
                change.location = JSON.parse(change?.country).name;
                // date
                change.referredOn = DateTime.fromISO(change.createdAt)
                    .toLocal()
                    .startOf("day")
                    .toJSDate();
                change.indexnumber = i;
                allData[i] = change;
                //phone number
                change.intlPhone = change.countryCode + " " + change.phoneNumber;
                //company
                change.company = companyName;


            }
            setReferralJson(allData || []);
            setIsloading(false)
        } catch (err) {
            console.log(err);
        }
        // }
    }

    const RenderSkill = () => {
        return (
            <section className="filter_box_referral">
                <label className="filter_label_referral">Skill</label>

                <Autocomplete
                    multiple
                    options={referralSkills}
                    getOptionLabel={(option) => option.name || ""}
                    value={filterSkill}
                    popupIcon={null}
                    renderInput={(params) => (
                        <TextField {...params} placeholder="Select Skill" />
                    )}
                    onChange={handleSkill}
                />
            </section>
        );
    };

    const RenderCountry = () => {
        return (
            <section className="filter_box_referral">
                <label className="filter_label_referral">Country</label>

                <Autocomplete
                    options={countryList}
                    getOptionLabel={(option) => option.name || ""}
                    value={filterCountry}
                    popupIcon={null}
                    renderInput={(params) => (
                        <TextField {...params} placeholder="Select Country" />
                    )}
                    onChange={handleCountry}
                />
            </section>
        );
    };

    const RenderStatus = () => {
        return (
            <section className="filter_box_referral">
                <label className="filter_label_referral">Status</label>

                <Autocomplete
                    multiple
                    options={referralStatus}
                    getOptionLabel={(option) => option.name || ""}
                    filterSelectedOptions
                    value={filterStatus}
                    popupIcon={null}
                    renderInput={(params) => (
                        <TextField {...params} placeholder="Select Status" />
                    )}
                    onChange={handleStatus}
                />
            </section>
        );
    };
    const handleSkill = (event, value) => {
        setFilterSkill(value || []);
    };
    const handleCountry = (event, value) => {
        setFilterCountry(value || null);
    };
    const handleStatus = (event, value) => {
        setFilterStatus(value || []);
    };

    const getCommunityStaticsData = async () => {
        try {
            const response = await getUsersById(idContextTest);
            const data = response?.data?.data;
            setRecruiterData(data);
            setCompany(data[0]?.recruitmentpartner.name)
            search(data[0]?.recruitmentpartnerId, data[0]?.recruitmentpartner.name);

        } catch (error) {
            console.log("error", error);
        }
    }

    const getAllPendingCandidateByInvitedId = async () => {

        var rId = idContextTest;
        let payload = {
            userType: userRole
        }
        let allPendingCandidateByInvitedId =
            await getAllPendingCandidateByInvitedIdResponse(rId, payload);

        if (allPendingCandidateByInvitedId.data.data) {
            let arr = [];
            let data = allPendingCandidateByInvitedId.data.data;

            if (data.length > 0) {
                for (let index = 0; index < data.length; index++) {
                    //Aging
                    let date = getDate(data[index].createdAt);
                    let dateOfInvite = data[index].createdAt;
                    let currentDate = DateTime.now().toISO();
                    const date1 = DateTime.fromISO(dateOfInvite);
                    const date2 = DateTime.fromISO(currentDate);
                    const diff = date2.diff(date1, ["days"]).toObject();
                    const difference = diff.days.toString().split(".")[0].includes("-")
                        ? 0
                        : diff.days.toString().split(".")[0];

                    // Test Expiry Date
                    const formattedDate = DateTime.fromISO(data[index].expiresOn)
                        .toLocal()
                        .startOf("day")
                        .toJSDate();

                    arr.push(
                        Object.assign(data[index], {
                            dateTime: date,
                            aging: difference,
                            testExpiry: formattedDate,
                        })
                    );
                }

                setPendingData(arr);

            }
        } else {
            setPendingData([]);
        }

    }

    useEffect(() => {
        if (userRecruitmentpartnerId) {
            getCommunityStaticsData();
            getReferralOptions();
            getAllPendingCandidateByInvitedId();
        }
    }, [userRecruitmentpartnerId, userType]);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.action-button-container')) {
                setDropdownOpen(null);
            }
        };

        if (dropdownOpen !== null) {
            document.addEventListener('click', handleClickOutside);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [dropdownOpen]);

    const getReferralOptions = async () => {
        const resp = await getallreferralskillResponse();
        setReferralSkills(resp?.data?.data);

    };

    const openCancelReferralModal = (value) => {
        setCancelCandidateDetails(value);
        const arr = [...pendingData];
        const data = arr.filter((item) => item.email === value.email);
        setRevokeCandidateDetails(data[0]);
        setOpenCancelModal(true);
    };

    const getDate = (date) => {
        let fullDate = "";
        fullDate =
            new Intl.DateTimeFormat("en", { day: "2-digit" }).format(new Date(date)) +
            "-" +
            new Intl.DateTimeFormat("en", { month: "long" }).format(new Date(date)) +
            "-" +
            new Intl.DateTimeFormat("en", { year: "numeric" }).format(
                new Date(date)
            ) +
            ", " +
            new Date(date).toLocaleTimeString(navigator.language, {
                hour: "2-digit",
                minute: "2-digit",
            });

        return fullDate;
    };

    const cancelAndUpdate = async () => {
        if (cancelCandidateDetails.status === "Invited to Test") {
            var payloadData = {
                isActive: false,
            };

            try {
                await revokeInviteCandidateResponse(
                    revokeCandidateDetails.id,
                    payloadData
                );
                getAllPendingCandidateByInvitedId();
                setRevokeCandidateDetails("");
            } catch (error) {
                console.log(error);
            }
        }

        const payload = {
            referralId: cancelCandidateDetails?.id,
            data: {
                status: "Referral Cancelled",
            },
        };

        try {
            await UpdateStatusReferralById(payload);
            getReferralWholeData(recruiterData);
            NotificationManager.success("Referral cancelled", "Success", 10000);
            search(recruiterData[0].recruitmentpartnerId, company);
        } catch (err) {
            console.log(err);
            NotificationManager.error(
                "Referral could not be cancelled",
                "Error",
                10000
            );
        }
        closeCancelReferralModal();
    };



    const getReferralWholeData = async (data) => {
        const payloadDataForReferral = {
            recruitmentPartnerId: data[0]?.recruitmentpartnerId,
            data: {
                skillId: [],
                country: "",
                status: ['Pending action'],
            },
        };
        try {
            const res = await SearchReferralByRecruitmentPartnerId(
                payloadDataForReferral
            );
            const allData = res?.data?.data;
            for (let i = 0; i < allData.length; i++) {
                let change = allData[i];
                // country
                change.location = JSON.parse(allData[i]?.country).name;
                // date
                change.referredOn = DateTime.fromISO(change.createdAt)
                    .toLocal()
                    .startOf("day")
                    .toJSDate();
                //phone number
                change.intlPhone = change.countryCode + " " + change.phoneNumber;
                // company
                change.company = company;
                allData[i] = change;

            }
            setReferralJson(allData || []);
        } catch (err) {
            console.log(err);
        }

    };

    const downloadResume = async (event, url) => {
        window.open(url, "_blank");
    };

    const closeCancelReferralModal = () => {
        setOpenCancelModal(false);
        setOpen(!open)
    };
    const cancelReferral = () => {
        cancelAndUpdate();
        setOpen(!open)
    };
    function create_UUID() {
        let dt = new Date().getTime();
        const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
            /[xy]/g,
            function (c) {
                const r = (dt + Math.random() * 16) % 16 | 0;
                dt >>>= 4; // unsigned right shift to ensure a 32-bit integer
                return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
            }
        );
        return uuid;
    }
    function hash_UUID(uuid) {
        return SHA256(uuid).toString();
    }

    const openCreateProfile = async (resumeurl, referralId, organizationId) => {
        const pathAfterDomain = resumeurl.replace(/^.*\/\/[^/]+/, ''); // Extracts everything after the domain
        const sasUrl = jsonConfig.sasToken;
        const sasResumeRepositoryUrl = jsonConfig.sasResumeToken;
        const sourceCdnUrlWithSas = `https://${jsonConfig.blobStorageAccountName}.blob.core.windows.net${pathAfterDomain}${sasUrl}`; // Replace with the CDN URL including SAS for the source blob
        const targetContainerSas = `https://${jsonConfig.blobStorageResumeAccountName}.blob.core.windows.net${sasResumeRepositoryUrl}`; // Replace with the target container SAS URL
        const date = DateTime.now().toFormat("yyyy-MM-dd");
        const uuid = create_UUID();
        const hashUuid = hash_UUID(uuid);
        let fileName = resumeurl.split('/').pop();
        let v = fileName.split(".");
        const targetBlobName = date + "/" + idContextTest + "/" + hashUuid + "." + v[v.length - 1];
        const targetBlobServiceClient = new BlobServiceClient(targetContainerSas);
        const targetBlobContainerClient = targetBlobServiceClient.getContainerClient("staging"); // Specify the container name
        const targetBlobClient = targetBlobContainerClient.getBlockBlobClient(targetBlobName);

        try {
            // Set metadata for the target blob container
            const currentTime = DateTime.utc().toFormat("yyyy-MM-dd'T'HH:mm:ss.SSSZZ");
            if (organizationId) {


                const metadata = {
                    "createdtime": currentTime,
                    "fullname": fileName,
                    "uploadedtype": "Recruiter Upload",
                    "isreferred": "true",
                    "referralid": referralId,
                    "organizationid": organizationId
                };

                // Copy source blob from CDN URL to target blob
                await targetBlobClient.beginCopyFromURL(sourceCdnUrlWithSas, {
                    metadata: metadata,
                });
                setProgressLoader(false)
                NotificationManager.success("Thank you! Your resumes are being uploaded and will be available shortly", "Success", 10000);

            }
            // search(recruiterData[0].recruitmentpartnerId, company);
        } catch (error) {
            console.error("Error copying blob:", error);
        }

    }

    const handleCandidateProfile = (resume_url, referral_id, organizationId) => {
        setResumeDetail({ "referralId": referral_id, "resumeUrl": resume_url, organizationId: organizationId })
        setOpenCandidateProfileModel(true);
    }

    const openModelCreateProfile = () => {
        let newReferralJson = [...referralJson]
        newReferralJson.splice(indexrow, 1);
        setReferralJson(newReferralJson);
        setOpenCandidateProfileModel(false);
        setOpen(!open);
        setProgressLoader(true);
        openCreateProfile(resumeDetail.resumeUrl, resumeDetail.referralId, resumeDetail.organizationId);

    }

    const closeModelCreateProfile = () => {
        setOpenCandidateProfileModel(false)
        setOpen(!open);
    }

    const handleDropdownClose = () => {
        setDropdownOpen(null);
        setSelectedRowData(null);
    };

    const handleInviteClick = (rowData) => {
        history(`/invite-candidates/${rowData.email}`, {
            state: {
                referralId: rowData.id,
            },
        });
        handleDropdownClose();
    };

    const handleCancelClick = (rowData) => {
        openCancelReferralModal(rowData);
        handleDropdownClose();
    };

    const handleCreateProfileClick = (rowData) => {
        handleCandidateProfile(rowData.resumeurl, rowData.id, rowData.referralpartner.recruitmentpartnerId);
        handleDropdownClose();
    };

    function dateFilterFn(row, columnId, filterValue) {
        if (!filterValue) return true; // no filter
        const rowValue = row.original.referredOn;
        if (!rowValue) return false;

        try {
            const rowDate = new Date(rowValue);
            const filterDate = new Date(filterValue);

            // Reset time to start of day for both dates to compare only date part
            rowDate.setHours(0, 0, 0, 0);
            filterDate.setHours(0, 0, 0, 0);

            return rowDate.getTime() === filterDate.getTime();
        } catch (error) {
            console.warn('Date filtering error:', error);
            return false;
        }
    }

    const getDateFilterValue = (column) => {
        const filterValue = column.getFilterValue();
        return filterValue ? new Date(filterValue) : null;
    }

    function ActionMenu({ row }) {
        const dropdownItems = getDropdownItems(row.original);
        const [anchorEl, setAnchorEl] = useState(null);
        const open = Boolean(anchorEl);

        const handleClick = (event) => {
            setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
            setAnchorEl(null);
        };

        return (
            <div className="referral-action-buttons-container">
                <Button
                    variant="contained"
                    size="small"
                    onClick={handleClick}
                    className="referral-action-button"
                >
                    Action
                </Button>
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                    }}
                >
                    <MenuItem
                        onClick={() => {
                            handleInviteClick(row.original);
                            handleClose();
                        }}
                        disabled={dropdownItems[0].disabled}
                    >
                        Invite
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            handleCancelClick(row.original);
                            handleClose();
                        }}
                        disabled={dropdownItems[1].disabled}
                    >
                        Cancel
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            handleCreateProfileClick(row.original);
                            handleClose();
                        }}
                        disabled={dropdownItems[2].disabled}
                    >
                        Create Profile
                    </MenuItem>
                </Menu>
            </div>
        );
    }

    const columns = [
        {
            id: "action",
            header: "Action",
            cell: ({ row }) => (
                <td>
                    <ActionMenu row={row} />
                </td>
            ),
            size: 150,
            enableSorting: false,
            enableColumnFilter: false,
        },
        {
            id: "Resume",
            header: "Resume",
            cell: ({ row }) => (
                <td>
                    <div
                        className="activityInviteBtnAllignment cp"
                        onClick={(e) =>
                            downloadResume(
                                e,
                                row.original.resumeurl
                            )
                        }
                    >
                        {row.original.resumeurl.substring(
                            row.original.resumeurl.length - 5,
                            row.original.resumeurl.length
                        ) === ".docx" ? (
                            <>
                                <img src={docIcon} alt="" />
                            </>
                        ) : (
                            <>
                                <img src={pdfIcon} width="39px" alt="" />
                            </>
                        )}
                    </div>
                </td>
            ),
            size: 80,
            enableSorting: false,
            enableColumnFilter: false,
        },
        {
            accessorKey: "skill.name",
            header: "Skill",
            size: 150,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: 'includesString',
        },
        {
            accessorKey: "company",
            header: "Company",
            size: 150,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: 'includesString',
        },
        {
            accessorKey: "location",
            header: "Location",
            size: 180,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: 'includesString',
        },
        {
            accessorKey: "email",
            header: "Email",
            size: 180,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: 'includesString',
        },
        {
            accessorKey: "intlPhone",
            header: "Phone Number",
            size: 180,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: 'includesString',
        },
        {
            accessorKey: "referredBy",
            header: "Referred By",
            size: 180,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: 'includesString',
        },
        {
            accessorKey: "referredOn",
            header: "Referred On",
            size: 150,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: dateFilterFn,
            Filter: ({ column }) => (
                <div className="date-picker-filter-container">
                    <DatePicker
                        selected={getDateFilterValue(column)}
                        onChange={(date) => {
                            column.setFilterValue(date ? date.toISOString() : '');
                        }}
                        dateFormat="MM/dd/yyyy"
                        placeholderText="Select date"
                        maxDate={new Date()}
                        isClearable
                        showIcon={true}
                        className="date-picker-table-filter"
                    />
                </div>
            ),
            cell: ({ row }) => (
                <>
                    {DateTime.fromISO(row.original.createdAt)
                        .toFormat("MM/dd/yyyy")
                        .toString()}
                </>
            )
        },
        {
            accessorKey: "status",
            header: "Status",
            size: 180,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: 'includesString',
        },

    ]

    const getDropdownItems = (dataItem) => {
        let inviteDisable = (userType === 'Admin' || dataItem.status === "Invited to Test" || dataItem.status === "Added to Community" || dataItem.status === "Referral Cancelled") ? true : false;
        let cancelDisabled = (userType === 'Admin' || dataItem.status === "Added to Community" || dataItem.status === "Referral Cancelled") ? true : false;
        // let isCandidateProfile = dataItem.candidateresumeformedbyrecruiters.candidateResumeId?true : false

        let arr = [
            {
                text: 'Invite',
                disabled: inviteDisable
            },
            {
                text: 'Cancel',
                disabled: cancelDisabled
            },
            {
                text: 'Create Profile',
            }
        ]
        return arr;
    }

    const goToDashboard = (e) => {
        history("/")
    }

    return (
        <>
            {(userType === "Candidate") ? (
                 <UnauthorizedAccess />
            ) : <>
                {progressLoader && (
                    <Backdrop sx={styleSx.backdrop} open={progressLoader}>
                        <CircularProgress color="inherit" className="circularprogress_mytalent" />
                        <Typography sx={styleSx.text} variant="h6">Generating Profile...</Typography>
                    </Backdrop>
                )}
                <div className='referralmainContainer'>
                    <Header />
                    {/* </Grid> */}
                    <div container className="referralMainGrid">
                        <div className="communityHeader_referral">
                            <div className="goBackButton" onClick={(e) => goToDashboard(e)}>
                                <Tooltip title="Go Back to Dashboard" placement="bottom">
                                    <ArrowBackIcon sx={{ fontSize: 20 }} />
                                </Tooltip>
                            </div>
                            <div className="communityTitle">Pending Referrals</div>
                        </div>
                        <div className='referral_content_maincontainer'>
                            <div className='filterContainer_referral'>
                                <div className='top_search_bar_referral'>

                                    <div className="top_search_text_referral">
                                        <div className="query_label_referral">
                                            <span className="query_value_manageUser">Showing Results : Referral</span>
                                        </div>
                                    </div>
                                    <button
                                        variant="contained"
                                        color="primary"
                                        className="search-btn"
                                        onClick={searchFunc}
                                    >
                                        Search
                                    </button>
                                </div>

                                <div className='referral_search_wrapper'>
                                    {referralMenuList.length > 0 &&
                                        referralMenuList.map((item, index) => {
                                            return (
                                                <div key={index}>
                                                    {item.checked &&
                                                        (() => {
                                                            switch (item.name) {
                                                                case "Skill":
                                                                    return <RenderSkill />;
                                                                case "Country":
                                                                    return <RenderCountry />;
                                                                case "Status":
                                                                    return <RenderStatus />;

                                                                default:
                                                                    return "";
                                                            }
                                                        })()}
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>

                            <div className='referralContent_rightSide'>
                                <DataTable
                                    data={referralJson}
                                    columns={columns}
                                    isLoading={isloading}
                                />
                            </div>
                        </div>

                    </div>
                    
                </div >
            </>
            }

            <Dialog
                open={openCancelModal}
                onClose={closeCancelReferralModal}
                aria-labelledby="customized-dialog-title"
            >
                <DialogContent
                    sx={styleSx.bodyForRemove}
                    className=" removemodal_responsive"
                >
                    <div className="text-center fs-semi-bold f-color fs-18">
                        Do you want to cancel referral for {cancelCandidateDetails.email}?
                    </div>
                </DialogContent>
                <DialogActions sx={styleSx.buttonContainer}>
                    <Button sx={styleSx.btnNO} onClick={closeCancelReferralModal}>No</Button>
                    <Button sx={styleSx.btnYES} onClick={cancelReferral}>Yes</Button>
                </DialogActions>
            </Dialog>
            {/* For create candidate  */}
            <Dialog
                open={openCandidateProfileModel}
                onClose={closeModelCreateProfile}
                aria-labelledby="customized-dialog-title"
            >
                <DialogContent
                    sx={styleSx.bodyForRemove}
                    className="removemodal_responsive"
                >
                    <div className="text-center fs-semi-bold f-color fs-18">
                        Do you want to create a Candidate profile ?
                    </div>
                </DialogContent>
                <DialogActions sx={styleSx.buttonContainer}>
                    <Button sx={styleSx.btnNO} onClick={closeModelCreateProfile}>No</Button>
                    <Button sx={styleSx.btnYES} onClick={openModelCreateProfile}>Yes</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default MyTalentReferral;

